import Axios from 'axios';
import { protectedResources } from '../authConfig';
import { cachedRequest, ATTENDANCE_CACHE_MS } from '../helpers/cachedRequest';

//const getAccessToken  = sessionStorage.getItem('AccessToken');
const URL =
  protectedResources.apiHRMobile.baseApi + '/api/v1/TimeInOut/GetLateInfo';
let tokenKey;

export async function getLateInfo(limit = 0, offset = 0, email = '') {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
    params: { 
      limit : limit,
      offset : offset,
      emailOrId : email 
    }
  };

  try {
    // Kept per user for a few minutes (it used to be kept for the whole session under one shared key).
    return await cachedRequest(
      `attendance_late_${(email || '').toLowerCase()}_${limit}_${offset}`,
      ATTENDANCE_CACHE_MS,
      async () => (await Axios.get(URL, config)).data
    );
  } catch (error) {
    if (error?.response?.status == 401) {
      localStorage.removeItem("obj_user_info");
      sessionStorage.removeItem("AccessToken");
      throw new Error("Unauthorized");
    }
    
    
    throw error;
  }
}
